import React, { useEffect, useState }  from 'react';
import '../../styles/recoverPage.scss'
import { BsArrowBarLeft } from 'react-icons/bs';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { MdPanoramaVerticalSelect } from 'react-icons/md';

const RecoverPage = () => {
    const [ serverID, setServerID] = useState('')
    const [ uncorectId, setUncorectId] = useState(false)
    const [ uncorectCode, setUncorectCode] = useState(false)
    const [ code, setCode] = useState('')
    const [ isLoadingServerID, setIsLoadingServerID] = useState(false)
    const [ isCorectServerID, setIsCorectServerID] = useState(false)
    const [ isLoadingCode, setIsLoadingCode] = useState(false)
    const [ isCorectCode, setIsCorectCode] = useState(false)

    useEffect(() => {
        if (serverID.length != 0){
            setTimeout(() => {
                setIsLoadingServerID(false)
                setIsCorectServerID(true)
                setUncorectId(true)
            },2000)
            
        } else if (isLoadingServerID) {
            setTimeout(() => {
                setIsLoadingServerID(false)
                setIsCorectServerID(true)
                setUncorectId(false)
            },2000)
        }
        if (code){
            setTimeout(() => {
                setIsLoadingCode(false)
                setIsCorectCode(true)
                setUncorectCode(true)
            },2000)
            
        }else if (isLoadingCode) {
            setTimeout(() => {
                setIsLoadingCode(false)
                setIsCorectCode(true)
                setUncorectCode(false)
            },2000)
        }
        
      },[isLoadingServerID, isLoadingCode])
      
      
    
    return (
        <div className='recovery_page_wrap'>
            <div className='recovery_page_wrap_content'>
                <div className='recovery_page_wrap_header'>
                    <h2>Server Recovery</h2>
                    <p>Don’t worry, we got you! This is where you can regain access to the server. </p>
                </div>
                <div className='recovery_page_wrap_body'>
                    <div className='recovery_page_block recovery_page_block_step_one'>
                        <h3>Step 1: Enter server details</h3>
                        <p>You have lost access to your physical owner account and you can no longer control Wick in this server? You are in the right place.</p>
                        <div className='recovery_page_input_wrap'>
                            <label htmlFor="serverId">Server ID:</label>
                            <input id='serverId' type="text" placeholder='0000000000000' value={serverID} onChange={(e) => setServerID(e.target.value)}/>
                            {isCorectServerID ?
                                    <div className='info-code'>
                                        {uncorectId ?
                                            <p className='corect-info'><AiOutlineCheckCircle/> Server found!</p>
                                            :
                                            <p className='uncorect-info'><AiOutlineCheckCircle/> Server not found!</p>
                                        }
                                    </div>
                                :
                                <>
                                    {isLoadingServerID ?
                                    <button className='button_loading' disabled>
                                        <img src="./img/server/Loading.svg" alt="" />
                                    </button>
                                    :
                                    <button onClick={() => setIsLoadingServerID(true)}>Verify</button>
                                    }
                                </>

                            }
                        </div>
                    </div>
                    <div className='recovery_page_block recovery_page_block_step_two'>
                        <h3>Step 2: Security Code</h3>
                        <p>To gain access, please enter the code from Google Authenticator</p>
                        <div className='block_step_two_ver-info'>
                            <div className='recovery_page_input_wrap block_step_two_ver-info-input '>
                                <label htmlFor="serverId">Enter your code::</label>
                                <input id='serverId' type="text" placeholder='000 000' value={code} onChange={(e) => setCode(e.target.value)} />
                                
                                {isCorectCode ?
                                    <div className='info-code'>
                                        {uncorectCode ?
                                            <p className='corect-info'><AiOutlineCheckCircle/> Server found!</p>
                                            :
                                            <p className='uncorect-info'><AiOutlineCheckCircle/> Server not found!</p>
                                        }
                                    </div>
                                :
                                <>
                                    {isLoadingCode ?
                                    <button className='button_loading' disabled>
                                        <img src="./img/server/Loading.svg" alt="" />
                                    </button>
                                    :
                                    <button onClick={() => setIsLoadingCode(true)} >Verify</button>
                                    }
                                </>

                            }
                            </div>
                            <img src="./img/recover/Google Authenticator UI.png" alt="Google Authenticator UI" />
                        </div>
                    </div>
                </div>
                <div className='recovery_page_wrap_footer'>
                    <button className='recovery_page_wrap_footer_btn-back'> <BsArrowBarLeft/> Nah, get me back</button>
                    <button 
                    // style={ !uncorectId || !uncorectId ? {background: '#2E3033', color:'#fff', boxShadow: '0 0 0 0'} : {}} 
                    className={`recovery_page_wrap_footer_btn-continue ${!uncorectId || !uncorectId ? 'recovery_page_wrap_footer_btn-back' : ''}`} 
                    disabled={!uncorectId || !uncorectId ? true : false}
                    onClick={() => console.log('work')} >Continue</button>
                </div>
            </div>
        </div>
    );
};

export default RecoverPage;